import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 20 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.194 5.025c.058.01.11.039.166.06.067.026.133.048.194.089l.038.018c.044.03.068.077.105.114s.084.062.117.106l.968 1.334 1.055 1.452a1 1 0 0 1-.222 1.396 1 1 0 0 1-1.396-.221L4 9.073q.005.452.079.903a5.978 5.978 0 0 0 2.425 3.9 6 6 0 0 0 2.092.959 6 6 0 0 0 2.38.084 6 6 0 0 0 2.228-.846 1 1 0 0 1 1.068 1.692 7.95 7.95 0 0 1-2.971 1.127 7.961 7.961 0 0 1-5.962-1.39 7.982 7.982 0 0 1-3.233-5.2A8 8 0 0 1 2 9.082l-.19.264A1 1 0 0 1 .19 8.17l1.056-1.451.949-1.307c.033-.044.078-.07.117-.106.037-.037.06-.083.104-.114.013-.01.026-.01.039-.018.06-.041.126-.063.193-.09.056-.02.109-.048.166-.06.063-.011.125-.006.19-.006.064 0 .127-.005.19.007m5.5-3.917a8 8 0 0 1 3.177.112 8.02 8.02 0 0 1 4.893 3.507 8 8 0 0 1 1.127 2.971c.068.415.094.831.098 1.245l.202-.276a.999.999 0 1 1 1.617 1.174l-1.054 1.452-.94 1.295c-.033.044-.08.07-.117.106-.037.037-.061.083-.105.114l-.038.018c-.061.041-.127.062-.194.09-.055.02-.108.048-.166.06-.063.011-.126.006-.19.006s-.127.005-.19-.007c-.058-.01-.11-.039-.166-.06-.067-.027-.132-.048-.193-.089-.013-.008-.026-.009-.04-.018-.042-.03-.066-.077-.103-.114-.038-.037-.084-.062-.117-.106l-.962-1.326-1.055-1.45a1 1 0 0 1 1.618-1.176l.195.268a6 6 0 0 0-.073-.88 5.978 5.978 0 0 0-2.425-3.899 6 6 0 0 0-2.092-.96 5.9 5.9 0 0 0-2.38-.084c-.8.132-1.55.416-2.228.845a1 1 0 1 1-1.068-1.69 8 8 0 0 1 2.97-1.128"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
